// extracted by mini-css-extract-plugin
export default {"teamContainer":"Team_teamContainer__5r7RH","memberContainer":"Team_memberContainer__y2G1R","teamMember":"Team_teamMember__6gLeN"};